import { get } from 'lodash-es'
import DeleteModal from '@/components/modals/delete-modal'
import SharedResource from '@/mixins/shared-resource'

export default {
  mixins: [SharedResource],
  components: {
    DeleteModal,
  },
  data() {
    return {
      resourceId: (this.resource && this.resource.id) || this.$route.params.id || null,
      isDeleting: false,
      deleteModalVisible: false,
    }
  },
  computed: {
    deletingResource() {
      if (this.isSingleResource) return get(this.resource, this.resourceKey, 'Loading')
      if (this.isMultipleResources)
        return get(
          this.resources.data.find(r => r.id === this.resourceId),
          this.resourceKey,
          'Loading'
        )
      return this.resourceId
    },
  },
  methods: {
    checkResourceIsDeleting(resourceId = null) {
      if (resourceId === null) return this.isDeleting
      return this.isDeleting && this.resourceId === resourceId
    },
    onResourceDeleteCancelled() {
      this.deleteModalVisible = false
    },
    async onResourceDeleteConfirmed() {
      const response = await this.deleteResource(this.resourceId)
      if (response) {
        this.$notify({
          type: 'success',
          text: `Successfully deleted ${this.resourceType?.toLowerCase() || 'resource'}`,
        })
      }

      if (this.isSingleResource) this.$router.push(this.redirectToIndexView())
      this.onResourceDeleteCancelled()
    },
    showDeleteModal(resourceId = null) {
      if (resourceId !== null) this.resourceId = resourceId
      if (resourceId === null && typeof this.$route.params.id !== undefined) this.resourceId = this.$route.params.id
      this.deleteModalVisible = !this.deleteModalVisible
    },
  },
}
